import React from 'react';
import _get from 'lodash.get';
import styled from 'styled-components';
import LiftCard from '@/components/LiftCard/LiftCard';
import Price from './ProductPrice';
import AddToCart from '@/components/Shop/AddToCartButton';

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Card = styled(LiftCard)`
  margin-bottom: 0;
  img {
    ${(props) => props.theme.media.desktopTablet`
      width: 100%;
      height: 258px;
      object-position: center center;
      object-fit: cover;
    `};
  }
  .placeholder-img {
    margin-bottom: 16px;
    ${(props) => props.theme.media.desktopTablet`
      height: 258px;
    `};
    ${(props) => props.theme.media.tablet`
      height: 108px;
      `}
    img {
      height: auto;
      margin-bottom: 0;
    }
  }
`;
const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  > span {
    flex: auto;
    display: flex;
    align-items: center;
  }
  ${(props) => props.theme.media.mobileSmall`
    margin-bottom: 32px;
    border-bottom: 1px solid ${props.theme.colors.kuluttaja2021.harmaa[10]};
  `}
`;

const ProductCard = (props) => {
  const { product } = props;
  const image = _get(product, 'images[0]', null);
  // Image we get from REST API is different than image from GraphQL
  const uniformImage = image
    ? { sourceUrl: image.src, altText: image.alt || image.name }
    : null;

  return (
    <CardWrapper>
      <Card
        title={product.name}
        image={uniformImage}
        categories={product.categories}
        link={product.permalink}
        placeholderImage
      />
      <Meta>
        <Price product={product} />
        <AddToCart product={product} buttonstyle="plain" />
      </Meta>
    </CardWrapper>
  );
};
export default ProductCard;
